import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const branchPurchasesWidget: DashboardWidgetConfiguration = {
  widgetId: "branch.purchases",
  name: "Branch purchases",
  description: "Branch purchases for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "procurement.purchases",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "total",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Purchases",
    subtext: "in the last 30 days",
    icon: "orders",
    color: "primary",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "0",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
